import { defaultSettingsSend } from './defaultSettings'
// usesettings
import { useState } from 'react'
import {
  Protocol,
  objToStringSettings,
} from '@orbital/games-frontend-library'
// declaration
export let settings: any = {
  ante: '1',
  audio: {
    sound: true,
    music: true,
    volume: 0.5,
  },
}
let setsettings: any
let sendSocketMessage: any

// initialization
export const useSettings = (func: any) => {
  return (
    ([settings, setsettings] = useState<any>(settings)),
    (sendSocketMessage = func)
  )
}

// getter
export const getSettings = () => settings

// setters
// set stakes

export const setStakes = (ante: any) => setsettings({ ...settings, ante })
export const setAudios = (audio: any) => setsettings({ ...settings, audio })

export const sendStakes = (ante: any) => {
  if (ante === settings.ante) {
    return
  }


  const stringified = objToStringSettings(
    {
      stake: [ante],
      minStake: defaultSettingsSend[0].minStake,
      maxStake: defaultSettingsSend[0].maxStake,
      sound: settings.audio.sound,
      music: settings.audio.music,
      volume: settings.audio.volume,
    },
    defaultSettingsSend,
  )
  setsettings({ ...settings, ante })
  sendSocketMessage(Protocol.USER_SETTINGS_POST, stringified)
}
export const setAudio = (audio: any) => {
  if (
    audio.sound === settings.audio.sound &&
    audio.music === settings.audio.music &&
    audio.volume === settings.audio.volume
  ) {
    return
  }

  const stringified = objToStringSettings(
    {
      stake: [settings.ante],
      minStake: defaultSettingsSend[0].minStake,
      maxStake: defaultSettingsSend[0].maxStake,
      sound: audio.sound,
      music: audio.music,
      volume: audio.volume,
    },
    defaultSettingsSend,
  )

  setsettings({ ...settings, audio })
  sendSocketMessage(Protocol.USER_SETTINGS_POST, stringified)
}
